import { render } from "./saleGeneral.vue?vue&type=template&id=93c1b4ae"
import script from "./saleGeneral.vue?vue&type=script&lang=js"
export * from "./saleGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__